import { ItemUser } from 'data/firestore/globals';
import CustomersInfo from 'components/CustomersInfo';
import useSessionCustomer from 'data/hooks/useSessionCustomer';
import { EntityGet } from 'data/firestore/types';
import { Session } from 'data/firestore/session/types';
import { UserCellWrapper } from '../styled';

interface Props {
    row?: EntityGet<Session>;
}

const UserColumn = ({ row }: Props) => {
    const { isLoading, customer } = useSessionCustomer(row as Session);
    const mappedCustomers = customer ? [{ ...customer, phoneNumber: customer.phoneNumber?.phoneNumber, role: 'customer' as const }] : [];

    return (
        <UserCellWrapper>
            <CustomersInfo customers={mappedCustomers as ItemUser[]} isLoading={isLoading} />
        </UserCellWrapper>
    );
};

export default UserColumn;
